// extracted by mini-css-extract-plugin
export default {"card":"T4-z"};